import React, { useState, useEffect } from "react";
import { ToastContainer, toast } from "react-toastify";
import Footer from "./Footer";
import Header from "./Header";
import { URLS } from "../Url";
import axios from "axios";
import { Helmet } from "react-helmet";
import {
  User,
  Phone,
  Mail,
  Calendar,
  MessageSquare,
  ArrowRight,
  Sparkles,
  Heart,
  Film,
  Cake,
  Building2,
  PartyPopper,
  MapPin,
} from "lucide-react";
import logo from "../components/carnival_footer_logo-2-removebg-preview.png";
import ThankYouModal from "../Blogs/ThankyouModal";
import "../styles/enquiry.css";

function Enquiry() {
  const [form, setform] = useState({
    name: "",
    email: "",
    mobileNumber: "",
    description: "",
    eventName: "",
  });

  const [isLoading, setIsLoading] = useState(false);
  const [Contact, setContact] = useState([]);
  const [thankYouModal, setThankYouModal] = useState(false);

  useEffect(() => {
    GetFooterData();
  }, []);

  const GetFooterData = () => {
    axios.post(URLS.GetFooter, {}, {}).then((res) => {
      if (res.status === 200) {
        setContact(res.data.contactus);
        setIsLoading(false);
      }
    });
  };

  const formsubmit = (e) => {
    e.preventDefault();
    EnquiryNow();
  };

  const handleChange = (e) => {
    let myUser = { ...form };
    myUser[e.target.name] = e.target.value;
    setform(myUser);
  };

  const EnquiryNow = () => {
    const dataArray = {
      name: form.name,
      email: form.email,
      mobileNumber: form.mobileNumber,
      description: form.description,
      eventName: form.eventName,
    };

    axios.post(URLS.AddEnquiry, dataArray).then(
      (res) => {
        if (res.status === 200) {
          toast(res.data.message);
          setform({
            name: "",
            email: "",
            mobileNumber: "",
            description: "",
            eventName: "",
          });
          setThankYouModal(true); // 🔥 Show thank you modal
        }
      },
      (error) => {
        if (error.response && error.response.status === 400) {
          toast(error.response.data.message);
        }
      }
    );
  };

  return (
    <>
      <Helmet>
        <meta charSet="utf-8" />
        <title>Plan Your Celebration | Carnival Castle Private Theatre</title>
        <meta
          name="description"
          content="Experience the perfect venue for Birthday surprises, Anniversary celebrations, Proposals, and Private Screenings at Carnival Castle."
        />
      </Helmet>

      {isLoading === true ? (
        <div
          className="text-center"
          style={{
            backgroundColor: "var(--charcoal-black)",
            height: "100vh",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            flexDirection: "column",
          }}
        >
          <div>
            <img
              src="assets/img/gipss.gif"
              style={{ height: "300px", color: "white" }}
              alt="Loading"
            />
            <h6 style={{ color: "gold" }}>Loading...</h6>
          </div>
        </div>
      ) : (
        <div className="enq-page-wrapper">
          <Header />
          <main className="main-wrapper enq-main-section">
            <div className="enq-container">
              {/* Refined Header */}
              <div className="enq-header">
                <span className="enq-eyebrow">✦ YOUR CELEBRATION BEGINS HERE ✦</span>
                <h1 className="enq-title">Let's Plan Your Celebration</h1>
                <p className="enq-subtitle">
                  Tell us a little about your special moment. Our celebration team will help craft an unforgettable private theatre experience.
                </p>
              </div>

              {/* Main Card Container */}
              <div className="enq-card">
                {/* Left: Editorial Information Panel */}
                <div className="enq-info-panel">
                  <div>
                    <div className="enq-brand-bar">
                      <img src={logo} alt="Carnival Castle" className="enq-brand-logo" />
                      <div className="enq-brand-divider" />
                    </div>

                    <h2 className="enq-info-heading">Plan Something Extraordinary</h2>
                    <p className="enq-info-copy">
                      From intimate birthdays to proposals, anniversaries and unforgettable private screenings, we'll help you create a celebration designed around your moment.
                    </p>

                    <div className="enq-occasions-heading">Celebration Types</div>
                    <div className="enq-occasions-list">
                      <div className="enq-occasion-chip">
                        <Cake className="enq-chip-icon" />
                        <span>Birthday</span>
                      </div>
                      <div className="enq-occasion-chip">
                        <Heart className="enq-chip-icon" />
                        <span>Anniversary</span>
                      </div>
                      <div className="enq-occasion-chip">
                        <Sparkles className="enq-chip-icon" />
                        <span>Proposal</span>
                      </div>
                      <div className="enq-occasion-chip">
                        <PartyPopper className="enq-chip-icon" />
                        <span>Special Surprise</span>
                      </div>
                      <div className="enq-occasion-chip">
                        <Film className="enq-chip-icon" />
                        <span>Private Screening</span>
                      </div>
                      <div className="enq-occasion-chip">
                        <Building2 className="enq-chip-icon" />
                        <span>Corporate Event</span>
                      </div>
                    </div>
                  </div>

                  <div className="enq-info-bottom">
                    <div className="enq-contact-line">
                      <MapPin className="enq-contact-icon" />
                      <span>{Contact?.address || "Hyderabad, Telangana"}</span>
                    </div>
                    <a href="tel:8341428342" className="enq-contact-line">
                      <Phone className="enq-contact-icon" />
                      <span>+91 8341428342</span>
                    </a>
                  </div>
                </div>

                {/* Right: Premium Concierge Form */}
                <div className="enq-form-panel">
                  <h2 className="enq-form-title">Your Details</h2>
                  <p className="enq-form-subtitle">
                    Share your celebration details below and our team will connect with you.
                  </p>

                  <form onSubmit={formsubmit}>
                    <div className="enq-form-grid">
                      {/* Full Name */}
                      <div>
                        <label className="enq-label">Full Name</label>
                        <div className="enq-input-wrap">
                          <User className="enq-input-icon" />
                          <input
                            required
                            type="text"
                            name="name"
                            value={form.name}
                            onChange={handleChange}
                            placeholder="Enter your full name"
                            className="enq-input-control"
                          />
                        </div>
                      </div>

                      {/* WhatsApp Number */}
                      <div>
                        <label className="enq-label">WhatsApp Number</label>
                        <div className="enq-input-wrap">
                          <Phone className="enq-input-icon" />
                          <input
                            required
                            type="text"
                            name="mobileNumber"
                            onChange={handleChange}
                            maxLength="10"
                            minLength="10"
                            pattern="[0-9]{10}"
                            value={form.mobileNumber}
                            placeholder="10-digit mobile number"
                            className="enq-input-control"
                          />
                        </div>
                      </div>

                      {/* Email Address */}
                      <div>
                        <label className="enq-label">Email Address</label>
                        <div className="enq-input-wrap">
                          <Mail className="enq-input-icon" />
                          <input
                            required
                            type="email"
                            name="email"
                            onChange={handleChange}
                            value={form.email}
                            placeholder="Enter your email address"
                            className="enq-input-control"
                          />
                        </div>
                      </div>

                      {/* Event / Occasion Name */}
                      <div>
                        <label className="enq-label">Occasion / Event Name</label>
                        <div className="enq-input-wrap">
                          <Calendar className="enq-input-icon" />
                          <input
                            required
                            type="text"
                            name="eventName"
                            onChange={handleChange}
                            value={form.eventName}
                            className="enq-input-control"
                            placeholder="e.g. Birthday, Proposal, Screening"
                          />
                        </div>
                      </div>

                      {/* Description Textarea */}
                      <div className="enq-field-full">
                        <label className="enq-label">About Your Celebration</label>
                        <div className="enq-input-wrap is-textarea">
                          <MessageSquare className="enq-input-icon" />
                          <textarea
                            required
                            rows={4}
                            name="description"
                            onChange={handleChange}
                            value={form.description}
                            className="enq-input-control enq-textarea-control"
                            placeholder="Tell us about your celebration, preferred date, theme or anything you'd like us to know..."
                          />
                        </div>
                      </div>
                    </div>

                    <div className="enq-actions-wrap">
                      <button type="submit" className="enq-cta-btn">
                        Plan My Celebration <ArrowRight size={16} />
                      </button>
                      <p className="enq-trust-line">
                        Our celebration team will get in touch with you to plan the details.
                      </p>
                    </div>
                  </form>
                </div>
              </div>
            </div>

            <ThankYouModal
              show={thankYouModal}
              onClose={() => setThankYouModal(false)}
            />
          </main>
          <ToastContainer />
          <Footer />
        </div>
      )}
    </>
  );
}

export default Enquiry;
